module.exports = __webpack_public_path__ + "img/KSC02228.46ace175.jpg";